<div class="filterTile" [class.selected]="checked" (click)="emitCustomValue()">
    <div class="filterText">
        <b style="font-size: 1.25em;">{{ NoOfRecords }}</b>
        <span class="filterName" matTooltip="{{ filterName }}">{{ filterName }}</span>
    </div>
    <mat-checkbox [checked]="checked" class="filterCheckbox"></mat-checkbox>
</div>
